'use strict';
const angular = require('angular');

/**
 * Variables
 */

var baseUrl; // base url for making requests to admin API



/*@ngInject*/
export function fetchService($http, baseConfigService) {
  baseUrl = baseConfigService.getBaseURL();
	
    // Get list of items
    this.getAllItems = function (url) {
      return $http.get(`${baseUrl}/${url}`);
  };

  // Get single item
  this.getItem = function (url,id) {
      return $http.get(`${baseUrl}/${url}/${id}`);
  };

  // Create new item
  this.createItem = function (url, data) {
      return $http.post(`${baseUrl}/${url}`, data);
  };
  // Update existing item
  this.updateItem = function (url, data) {
      return $http.post(`${baseUrl}/${url}`, data);
  };

    // Update existing item
    this.putItem = function (url) {
      return $http.put(`${baseUrl}/${url}`);
  };

  // Delete item
  this.deleteItem = function (url, id) {
      return $http.delete(`${baseUrl}/${url}/${id}`);
  };
}

export default angular.module('appApp.fetch', [])
  .service('fetch', fetchService)
  .name;



// WEBPACK FOOTER //
// ./client/components/services/fetch/fetch.service.js